import React, { useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGuitar, faTent, faHeadset } from "@fortawesome/free-solid-svg-icons";
import { faUser } from "@fortawesome/free-solid-svg-icons";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { changeLangFunc, changeModeFunc } from "../redux/actions";
import { FiSun, FiMoon } from "react-icons/fi";
import "./Footer.css";
import Cookies from "js-cookie";

const Footer = (props) => {
  const [full, setFull] = React.useState(false);

  const lang = useSelector((state) => state.reducer1.lang);
  const mode = useSelector((state) => state.reducer1.mode);

  function toggle() {
    // setTog(!tog);
    if (lang === "en") {
      document.getElementById("enBtn").style.backgroundColor = "transparent";
      document.getElementById("jpBtn").style.backgroundColor = "#192F83";
      document.getElementById("enBtn").style.color = "#192F83";
      document.getElementById("jpBtn").style.color = "white";
    } else {
      document.getElementById("enBtn").style.backgroundColor = "#192F83";
      document.getElementById("jpBtn").style.backgroundColor = "transparent";
      document.getElementById("enBtn").style.color = "white";
      document.getElementById("jpBtn").style.color = "#192F83";
    }
  }

  useEffect(() => {
    if (lang === "jp") {
      document.getElementById("enBtn").style.backgroundColor = "transparent";
      document.getElementById("jpBtn").style.backgroundColor = "#192F83";
      document.getElementById("enBtn").style.color = "#192F83";
      document.getElementById("jpBtn").style.color = "white";
    } else {
      document.getElementById("enBtn").style.backgroundColor = "#192F83";
      document.getElementById("jpBtn").style.backgroundColor = "transparent";
      document.getElementById("enBtn").style.color = "white";
      document.getElementById("jpBtn").style.color = "#192F83";
    }
  }, []);

  // useEffect(() => {
  //   document.getElementById("tog").style.left = lang==="en" ? "2.4rem" : "5.3rem";
  // }, []);

  const dispatch = useDispatch();

  return (
    <div
    className="footerCont"
      style={{
        position: "absolute",
        bottom: 0,
        zIndex: "100",
        width: "100vw",
        color: "white",
        // border: "2px solid red",
        alignItems: "center",
        padding: "20px",
      }}
    >
      {!full && (
        <div className="icons3">
          <a
            href="#"
            style={{
              // border:"2px solid red",
              display: "grid",
              placeItems: "center",
              fontSize: "1.5rem",
              backgroundColor: "white",
              borderRadius: "10px",
              padding: "8px",
              marginRight: "1rem",
            }}
          >
            <FontAwesomeIcon
              beatFade
              className="fa-guitar"
              icon={faTent}
              color="lime"
            />
          </a>

          <a
            href="#"
            style={{
              display: "grid",
              placeItems: "center",
              fontSize: "1.5rem",
              backgroundColor: "white",
              borderRadius: "10px",
              padding: "8px",
              marginRight: "1rem",
              color: "white",
              width: "1.7rem",
            }}
          >
            <div className="gg-instagram-one"></div>
          </a>

          <a
            href="#"
            style={{
              display: "grid",
              placeItems: "center",
              fontSize: "1.5rem",
              backgroundColor: "white",
              borderRadius: "10px",
              padding: "8px",
              marginRight: "1rem",
              width: "1.7rem",
            }}
          >
            <FontAwesomeIcon className="fa-guitar" icon={faHeadset} size="xs" />
          </a>
        </div>
      )}

      {!full && (
        <div
        className="modeBtn"
          onClick={() => {
            dispatch(changeModeFunc());
          }}
          style={{
            marginLeft: "auto",
            placeItems: "center",
            // alignItems: "center",
            fontSize: "1.5rem",
            cursor: "pointer",
            marginRight: "2rem",
            // border: "2px solid black",
            // backgroundColor: "red",
            backgroundColor: "#192F83",
            borderRadius: "100%",
            // position: "relative",
            padding: ".7rem",
            // color: "red",
          }}
        >
          {mode === "day" ? <FiSun /> : <FiMoon />}
        </div>
      )}

      {!full && (
        <div
          onClick={() => {
            dispatch(changeLangFunc());
            toggle();
            //change title of the app
            if (lang === "en") {
              Cookies.set("lang", "jp", { secure: true, expires: 7 });
              document.title = "イベント事例 | Regionport - 成功事例の紹介 - Works」";
            } else {
              Cookies.set("lang", "en", { secure: true, expires: 7 });
              document.title = "Event examples | Regionport - Introducing success stories - Works";
            }
          }}
          className="interFont langBtn"
          style={{
            // marginLeft: "auto",
            alignItems: "center",
            fontSize: "1.1rem",
            cursor: "pointer",
            marginRight: "3rem",
            border: "2px solid black",
            backgroundColor: "white",
            borderRadius: "30px",
            // position: "relative",
            padding: "0.2rem",
            // color: "white",
          }}
        >
          <p
            id="enBtn"
            style={{
              // marginRight: "0rem",
              backgroundColor: "#192F83",
              padding: "11px 8px 8px 8px",
              borderRadius: "100%",
              // color: "white",
            }}
          >
            EN
          </p>
          <p
            id="jpBtn"
            style={{
              backgroundColor: "transparent",
              padding: "9px 9px 7px 9px",
              borderRadius: "100%",
              color: "#192F83",
            }}
          >
            JP
          </p>
        </div>
      )}

      <p
        id="full"
        style={{
          marginRight: "3rem",
          marginTop: "-9rem",
          cursor: "pointer",
        }}
        onClick={() => {
          setFull(!full);
          if (!full) {
            document.getElementById("full").style.marginLeft = "auto";
          } else {
            document.getElementById("full").style.marginLeft = "0";
          }
          props.fullScreen();
        }}
      >
        <img src="/img/expand.png" alt="" />
      </p>
    </div>
  );
};

export default Footer;
